import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputNameSF from '../../widgets/form/InputNameSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import InputFieldUI from '../../widgets/form/InputFieldUI'
import InputSelectUI from '../../widgets/form/InputSelectUI'

const UserInviteByEmailUI = ({context, messageList,
  // email
  email, onEmailChange, emailError, setEmailError,
  // name
  firstName, lastName, onFirstNameChange, onLastNameChange, firstNameError, lastNameError, setFirstNameError, setLastNameError,
  // account role
  accountRoleId, accountRoleList, onaccountRoleIdChange, accountRoleIdError,
  // projects
  projectList, onProjectChange,
  // project role
  projectRoleId, projectRoleList, onprojectRoleIdChange, projectRoleIdError,
  // message
  message, onMessageChange, messageError, setMessageError,
  // form
  onSubmit, submitted, successMsg, errorList, setErrorList,
  }) =>
  <CardUI context={context}>
    <FormSF context={context} messageList={messageList} buttonMessageKey='c_invite'
      onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
      busy={submitted}>
      <InputTextSF type='text' name='email' required={true} maxLength={64}
        messageList={messageList} labelKey='c_email'
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
        autoFocus={true}
      />
      <InputNameSF type='name' name='name' firstName={firstName} lastName={lastName}
        messageList={messageList} labelKey='c_name'
        firstNameError={firstNameError} lastNameError={lastNameError}
        onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange}
        setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
      />
      <InputSelectUI name='accountRoleId' value={accountRoleId} required={true}
        messageList={messageList} labelKey='c_account_role'
        optionList={accountRoleList}
        onChange={onaccountRoleIdChange} error={accountRoleIdError}
      />
      {
        projectList && projectList.length > 0 &&
        <InputFieldUI messageList={messageList} labelKey='c_projects'>
          {
            projectList.map((project, i) =>
              <div key={i} onClick={onProjectChange} data-key={project.projectId}>
                <input type="checkbox" checked={project.selected} onChange={() => {}}
                />
                {project.projectName}
              </div>
            )
          }
        </InputFieldUI>
      }
      {
        projectRoleList && projectRoleList.length > 0 &&
        <InputSelectUI name='projectRoleId' value={projectRoleId}
          messageList={messageList} labelKey='c_project_role'
          optionList={projectRoleList}
          onChange={onprojectRoleIdChange} error={projectRoleIdError}
        />
      }
      <InputTextSF type='text' name='message' maxLength={250}
        messageList={messageList} labelKey='c_message'
        value={message} onChange={onMessageChange}
        error={messageError} setError={setMessageError}
      />
    </FormSF>
  </CardUI>

export default UserInviteByEmailUI
